import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";

export default class VendorParserController {
  constructor(options) {
    console.debug("VendorParserController", { that: this, options });
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.bus = new ServiceBus();
  }

  submit() {
    const $ctrl = this;
    const IdIn = ($ctrl.vendorIds || "NO_VENDOR_ID").split(/[\s,]+/gi).filter(vendorid => !!vendorid);
    const request = {
      IdIn,
      take: 500,
      fields: "Id"
    };
    $ctrl.bus.send("QueryVendors.json", request).then(({ data }) => {
      $ctrl.$close(data.results.map(p => p.id));
    });
  }

  $onDestroy() {
    this.bus.dispose();
  }
}
